import React from 'react'
import { Link } from 'react-router-dom'

import { array, object, string, func } from 'prop-types'

import styles from './MobileMenu.styl'

export default class MobileMenu extends React.Component {

	static propTypes = {
		logo: object,
		navigation: array,
		className: string,
		closeMenu: func
	}

	static defaultProps = {
		closeMenu: () => null
	}

	state = {
		isOpen: false,
		show: false
	}

	componentWillUnmount() {
		const { window } = this.context
		if (window) {
			window.document.body.classList.remove('no-scroll')
		}
	}

	renderNavication(navigation = [], closeMenu) {
		return navigation.map((item, index) => (
			<li
				key={ index }
				className={ styles['nav-entry'] }
				onClick={ () => { closeMenu() } }
				style={ { animationDelay: `${ (index * 100) + 250 }ms` } }
			>
				{ item.to ? <Link to={ item.to }>{ item.name }</Link> : item.name }
			</li>
		))
	}
	render() {
		const { logo, closeMenu, navigation } = this.props
		return (
			<div
				className={ styles['menu'] }
			>
				<div className={ styles['backdrop'] } />
				<div className={ styles['content'] }>
					<div className={ styles['header'] }>
						{ (
							logo ?
								(
									<Link to="/" className={ styles['logo-link'] } onClick={ closeMenu }>
										<img className={ styles.logo } src={ logo ? logo.thumb.url : null } />
									</Link>
								) :
								null
						) }
					</div>
					<div className={ styles['nav'] }>
						<ul>
							{ this.renderNavication(navigation, closeMenu) }
						</ul>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/components/MobileMenu/MobileMenu.js